import { Link } from 'react-router-dom';



export default function Intro (){
  return (
    <div className='relative flex items-center justify-start w-full  projects-background rounded-t-3xl bottom-[22px]'>
        <div className='flex flex-col-reverse items-start justify-end w-full gap-y-10 md:gap-0 md:flex-row '>
        <div className='flex flex-col  justify-center w-[100%] sm:w-[70%] md:w-[53%] px-16 pt-28 pb-32 rounded-t-3xl sm:rounded-l-3xl  md:rounded-tr-3xl text-[#303030] bg-[white] items-start gap-y-4 '>
            <h1 className='text-3xl font-extrabold md:text-4xl xl:text-6xl'>My<br/><span className='relative block bottom-[17px] left-[28px]'>Projects</span></h1>
            <p className=' text-[14px] lg:text-[15px] xl:text-[17px] w-[100%] sm:w-[95%] md:w-[85%] lg:w-[80%]'>My projects are created using HTML, CSS, JavaScript, Bootstrap, Tailwind, React.js, Redux, Next.js, Python, and FastAPI. I implemented authentication integration with Firebase and Google, as well as stripe integration. Additionally, I collaborated with backend developers for API integration. In some projects, I also managed the backend independently.</p>
            <Link to={'/contact-me'}>
            <button className=" px-4 text-sm rounded-3xl hover:bg-black hover:text-white hover:border-white py-[13px] font-medium transition-all duration-300 text-black bg-[#fdfdfd] border-[1px] border-black " title='Contact with Me'>
       Contact Me
        </button>
        </Link>    
        </div>
        
       
        </div>
    </div>
  )
}
